import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { confirmer } from "@/lib/confirmer";

const Modele = ({ m, canaux, variables, onMaj }) => {
  const [v, setV] = useState(m);
  const enr = () => api.post("/modeles-messages", v).then(() => { toast.success("Modèle enregistré."); onMaj(); }).catch((e) => toast.error(messageErreur(e)));
  const suppr = () => confirmer(`Mettre « ${m.nom} » à la corbeille ?`).then((ok) => ok && api.delete(`/modeles-messages/${m.id}`).then(() => { toast.success("Modèle mis à la corbeille."); onMaj(); }).catch((e) => toast.error(messageErreur(e))));
  const cle = m.id || "nouveau";
  return (
    <section className="at-card p-4 space-y-2 min-w-0" data-testid={`template-${cle}`}>
      <div className="grid grid-cols-[1fr_auto] gap-2">
        <input value={v.nom} onChange={(e) => setV({ ...v, nom: e.target.value })} placeholder="Nom du modèle" className="at-input font-bold" data-testid={`template-name-${cle}`} />
        {m.id && <button type="button" onClick={suppr} className="at-icon-btn" aria-label="Corbeille" data-testid={`template-trash-${cle}`}><Trash2 size={16} /></button>}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Object.entries(canaux).map(([c, l]) => <button key={c} type="button" onClick={() => setV({ ...v, canal: c })} className="at-btn !px-2 text-sm" style={{ background: v.canal === c ? "var(--accent)" : "var(--surface-2)", color: v.canal === c ? "var(--accent-ink)" : "var(--ink)" }} data-testid={`template-channel-${cle}-${c}`}>{l}</button>)}
      </div>
      {v.canal === "email" && <input value={v.sujet || ""} onChange={(e) => setV({ ...v, sujet: e.target.value })} placeholder="Objet de l'e-mail" className="at-input" data-testid={`template-subject-${cle}`} />}
      <textarea value={v.texte} onChange={(e) => setV({ ...v, texte: e.target.value })} rows={4} className="at-input !h-auto py-2" data-testid={`template-text-${cle}`} />
      <div className="flex flex-wrap gap-1">{variables.map((x) => <button key={x} type="button" onClick={() => setV({ ...v, texte: `${v.texte}{${x}}` })} className="text-xs at-pill px-2.5 min-h-[44px]" style={{ background: "var(--surface-2)" }} data-testid={`template-var-${cle}-${x}`}>{`{${x}}`}</button>)}</div>
      <button type="button" onClick={enr} className="at-btn at-btn-primary w-full" data-testid={`template-save-${cle}`}>Enregistrer</button>
    </section>
  );
};

export default function Modeles() {
  const [d, setD] = useState(null);
  const [nouveau, setNouveau] = useState(false);
  const charger = useCallback(() => api.get("/modeles-messages").then((r) => { setD(r.data); setNouveau(false); }).catch((e) => toast.error(messageErreur(e))), []);
  useEffect(() => { charger(); }, [charger]);
  if (!d) return <p className="at-muted">Chargement…</p>;
  return (
    <div className="space-y-4" data-testid="templates-settings">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h2 className="text-base md:text-lg font-bold">Modèles de messages</h2><p className="text-sm at-muted">SMS, e-mail et WhatsApp (envois simulés). Touchez une variable pour l'insérer.</p></div>
        <button type="button" onClick={() => setNouveau(true)} className="at-btn at-btn-ghost" data-testid="template-add"><Plus size={15} />Nouveau modèle</button>
      </div>
      <div className="grid xl:grid-cols-2 gap-3">
        {nouveau && <Modele m={{ nom: "", canal: "sms", sujet: "", texte: "" }} canaux={d.canaux} variables={d.variables} onMaj={charger} />}
        {d.modeles.map((m) => <Modele key={m.id} m={m} canaux={d.canaux} variables={d.variables} onMaj={charger} />)}
      </div>
    </div>
  );
}
